// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 989 ? "component---src-core-pages-page-template-tsx" : chunkId) + "-" + {"530":"13495be2d00347319016","989":"7b62db207b906e3dcbdc"}[chunkId] + ".js";
};